import { IHandbookRelations, IHandbooksState } from './types'

export const DEFAULT_SINGLE_VALUE_RELATIONS_SCOPE = 'default'

export const getHandbookRelationsScopeKey = (scopeKey?: string): string =>
  scopeKey ?? DEFAULT_SINGLE_VALUE_RELATIONS_SCOPE

export const getSingleValueRelationsByScope = (
  state: IHandbooksState,
  scopeKey?: string
): IHandbookRelations => {
  const resolvedScopeKey = getHandbookRelationsScopeKey(scopeKey)

  if (resolvedScopeKey === DEFAULT_SINGLE_VALUE_RELATIONS_SCOPE) {
    return state.singleValueRelations
  }

  return state.singleValueRelationsByScope?.[resolvedScopeKey] ?? {}
}

export const getSingleValueRelationsTableByScope = (
  state: IHandbooksState,
  scopeKey?: string
): IHandbookRelations[] => {
  const resolvedScopeKey = getHandbookRelationsScopeKey(scopeKey)

  if (resolvedScopeKey === DEFAULT_SINGLE_VALUE_RELATIONS_SCOPE) {
    return state.singleValueRelationsTable
  }

  return state.singleValueRelationsTableByScope?.[resolvedScopeKey] ?? []
}
